/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import ReferredPatientsidReferredPatient from './ReferredPatientsidReferredPatient';

/**
 * The ReferredPatientsIdBody model module.
 * @module model/ReferredPatientsIdBody
 * @version v0.3
 */
export default class ReferredPatientsIdBody {
  /**
   * Constructs a new <code>ReferredPatientsIdBody</code>.
   * @alias module:model/ReferredPatientsIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ReferredPatientsIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ReferredPatientsIdBody} obj Optional instance to populate.
   * @return {module:model/ReferredPatientsIdBody} The populated <code>ReferredPatientsIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ReferredPatientsIdBody();
      if (data.hasOwnProperty('referred_patient'))
        obj.referredPatient = ReferredPatientsidReferredPatient.constructFromObject(data['referred_patient']);
    }
    return obj;
  }
}

/**
 * @member {module:model/ReferredPatientsidReferredPatient} referredPatient
 */
ReferredPatientsIdBody.prototype.referredPatient = undefined;

